import remoteConfig from '@react-native-firebase/remote-config';
import {mapValues} from 'lodash';

import {MS_IN_HOUR} from '/constant/time.constant';
import {getErrorTrackingUtilDefaultInstance} from '/util/error-tracking/error-tracking.util';
import {log} from '/util/logger.util';

export class FirebaseRemoteConfigBackend {
  activated: any;

  remoteConfig: any;

  verbose: any;

  constructor({verbose}: any = {}) {
    this.verbose = verbose;

    this.activated = false;
    this.remoteConfig = remoteConfig;
  }

  setDefaults(defaults = {}) {
    if (this.verbose) {
      log('[FirebaseRemoteConfig] setting defaults', defaults);
    }

    return this.remoteConfig().setDefaults(defaults);
  }

  fetchAndActivate() {
    if (this.activated) {
      if (this.verbose) {
        log('[FirebaseRemoteConfig] already activated');
      }

      return Promise.resolve();
    }

    return this.remoteConfig()
      .setConfigSettings({
        // Set `minimumFetchIntervalMillis` as `0`
        // if you need to reset the Remote Config cache data.
        minimumFetchIntervalMillis: MS_IN_HOUR,
      })
      .then(() => this.remoteConfig().fetchAndActivate())
      .then(() => (this.activated = true));
  }

  getAll() {
    return this.fetchAndActivate()
      .then(() => this.remoteConfig().getAll())
      .then((configVars: any) => {
        if (this.verbose) {
          log('[FirebaseRemoteConfig] config variables', configVars);
        }

        return mapValues(configVars, (el: any) => el.asString());
      })
      .catch((error: any) => {
        getErrorTrackingUtilDefaultInstance().trackError(
          error,
          'RemoteConfig Error',
        );
      });
  }
}
